module.exports = __webpack_public_path__ + "img/asset_soFTT.ae13b098.svg";